const formatMerkleData = (merkleData) => {
  if (!merkleData || typeof merkleData !== "object") {
    return merkleData;
  }
  const transformed = {};
  const mapping = {
    "merkury_confidence_score": "merkleConfidenceScore",
    "merkury_cmid": "merkleCmid",
    "merkury_hmid": "merkleHmid"
  };
  for (const [key, value] of Object.entries(merkleData)) {
    if (mapping[key]) {
      transformed[mapping[key]] = value;
    }
  }
  return transformed;
};
const formatUtmParams = (utmParams) => {
  if (!utmParams || typeof utmParams !== "object") {
    return utmParams;
  }
  const transformed = {};
  Object.entries(utmParams).forEach(([key, value]) => {
    const camelCaseKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    transformed[camelCaseKey] = value;
  });
  return transformed;
};
export {
  formatMerkleData,
  formatUtmParams
};
